document.addEventListener("DOMContentLoaded", function () {
  try {
    const opts = document.querySelectorAll(".options-selection__option-value-input");
    
    opts.forEach((opt) => {
      opt.addEventListener("change", (e) => {
        const form = document.querySelector("variant-selection");
        const variant_id = form.getAttribute("variant");
        const selectedVariant = document.querySelector(`#var_${variant_id}`);
        
        if (!selectedVariant) return; // If no selected variant, exit early
        
        const metaVal = JSON.parse(selectedVariant.getAttribute("data-meta"));
        const props = document.querySelector("input[name='properties[Bin no]']");
        if (props) props.value = metaVal["bin_no_"];
        console.log("Meta Data:", metaVal);
        console.log('');
        // Remove 'active' class from previous variant
        document.querySelector(".descrption-meta.active")?.classList.remove("active");
        document.querySelector(".descrption-metas.active")?.classList.remove("active");

        // Add 'active' class to the selected variant's metafield section
        if (variant_id) {
          document.querySelector(`[data-variant-id="${variant_id}"]`)?.classList.add("active");
          document.querySelector(`[data-id="${variant_id}"]`)?.classList.add("active");
        }
      });
    });
  } catch (err) {
    console.error("Meta Set Error:", err);
  }
});
